import { useForm } from 'react-hook-form';
import useRegister, { Register } from '../../api/hooks/authentication/useRegister';
import { settingsInputs } from '../../consts/inputs';
import { toIcons } from '../../consts/Paths';
import useIsMobile from '../../hooks/useIsMobile';
import { getInputs } from '../../utils/getMethods';
import CustomInput from '../inputs/CustomInput';
import { useEffect } from 'react';
import useLogMessage from '../../hooks/useLogMessage';
import useToggle from '../../hooks/useToggle';
import LogMessage from '../misc/LogMessage';
import { logMsgBgColors } from '../../consts/misc';
import useCategory from '../../api/hooks/useCategory';
import useOffer from '../../api/hooks/useOffers';
import useManufacturers from '../../api/hooks/useManufacturers';

const SettingsCreateManufacturersModal = (props: any) => {
    const { CTAs, RESPONSES } = useManufacturers();
    const { isMobile } = useIsMobile();
    const createNewManufacturerForm = useForm();
    const { write } = props.logMessage;

    const onSubmit = (data: any) => {
        /* console.log("calling: create new user form"); */
        CTAs.createManufacturer(data);
    };

    /* Setting Messsage */
    useEffect(() => {
        /* console.log(registerResponse, registerResult); */
        if (RESPONSES.manufacturerResponse?.ok) {
            write('subject', 'Category ');
            write('other_text', 'has been added ');
            write('complement', 'successfully!');
            write('bgColor', logMsgBgColors.correct);
            props.toggler.toggle();
            props.resetList.toggle();
        } else if (RESPONSES.manufacturerResponse?.ok === false) {
            write('subject', 'Category ');
            write('other_text', 'has not been addedd');
            write('complement', 'try again');
            write('bgColor', logMsgBgColors.error);
        }
    }, [RESPONSES.manufacturerResponse]);
    /*  */

    // const inputsArray = getInputs(settingsInputs, ['cod', 'address', 'phone', 'description', 'email', 'ordering']);
    // const renderInputs = inputsArray.map((input, key) => {
    //     return (
    //         <CustomInput
    //             key={key}
    //             width={isMobile ? '100%' : 564}
    //             title={input.title}
    //             name={input.name}
    //             type={input.type}
    //             register={createNewUserForm.register}
    //             errors={createNewUserForm.formState.errors}
    //             {...input}
    //         />
    //     );
    // });

    return (
        <div
            className='modal-wrapper'
            style={{
                height: `100vh`,
            }}
        >
            <div
                className='settings-edit-modal'
                style={{
                    width: isMobile ? '345px' : '',
                }}
            >
                <form onSubmit={createNewManufacturerForm.handleSubmit(onSubmit)}>
                    <div className='settings-edit-modal-content' style={{ margin: isMobile ? '35px 19px 0 21px' : '' }}>
                        <div className='modal-header'>
                            <p className='modal-title'>Add produttore</p>
                            <div className='Oval' onClick={props.toggler.toggle}>
                                <img src={`${toIcons}/close.svg`} />
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '25px',
                                marginTop: '22px',
                            }}
                        >
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Company Name'
                                name='companyName'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: true }} // unique
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Address Line 1'
                                name='addressLine1'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Address Line 2'
                                name='addressLine2'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='City'
                                name='city'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Country'
                                name='country'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Postal Code'
                                name='postalCode'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='State or Province'
                                name='stateOrProvince'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Phone'
                                name='phone'
                                type='number'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Email'
                                name='email'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <hr />
                            {/* Responsible Person Fields */}
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Company Name'
                                name='responsible_companyName'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: true }} // obbligatorio
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Address Line 1'
                                name='responsible_addressLine1'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Address Line 2'
                                name='responsible_addressLine2'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible City'
                                name='responsible_city'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Country'
                                name='responsible_country'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Postal Code'
                                name='responsible_postalCode'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible State or Province'
                                name='responsible_stateOrProvince'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Phone'
                                name='responsible_phone'
                                type='number'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Responsible Email'
                                name='responsible_email'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                            <hr />
                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Matching Brand'
                                name='matching_brand'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: true }} // unique
                            />

                            <CustomInput
                                width={isMobile ? '100%' : 564}
                                title='Certification Document'
                                name='certDoc'
                                type='text'
                                register={createNewManufacturerForm.register}
                                errors={createNewManufacturerForm.formState.errors}
                                constraints={{ required: false }} // nullable
                            />
                        </div>
                        <button
                            style={{
                                marginRight: '0',
                                width: isMobile ? '100%' : '105px',
                            }}
                            className='modal-button'
                            type='submit'
                        >
                            <p className='modal-button-text'>Add</p>
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default SettingsCreateManufacturersModal;
